import React from 'react';
import { Ribbon } from '@dls/web';

export const accessoryRibbon = (isCIS = false) => (accessory: {
  ribbonCIS?: string;
  ribbon?: string;
}) => {
  switch (isCIS) {
    case true:
      return accessory?.ribbonCIS ? (
        <Ribbon.Variant1>{accessory.ribbonCIS}</Ribbon.Variant1>
      ) : null;
    case false:
      return accessory?.ribbon ? (
        <Ribbon.Variant1>{accessory.ribbon}</Ribbon.Variant1>
      ) : null;
    default:
      return null;
  }
};
